import cn from 'classnames';

import { IConDefaultType } from '..';

export enum CharacterRIconVariant {
  ON = 'on',
  OFF = 'off',
}

export interface ICharacterRIconProps extends IConDefaultType {
  variant?: CharacterRIconVariant;
}

function CharacterRIcon({
  color,
  className,
  size = 24,
  rotate,
  flip,
  variant = CharacterRIconVariant.OFF,
}: ICharacterRIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      {variant === CharacterRIconVariant.OFF && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="12" fill="#8A8A8A" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.4753 13.7197V18H7.6189V6.00293H12.699C15.6609 6.00293 17.1199 7.67285 17.1199 9.93164C17.1199 11.9092 15.7927 12.9814 14.9753 13.3154L17.366 18H14.1492L12.1189 13.7197H10.4753ZM10.4753 11.6631H12.2419C13.3669 11.6631 14.1228 11.0918 14.1228 9.95801C14.1228 8.77148 13.3054 8.18262 12.2683 8.18262H10.4753V11.6631Z"
            fill="white"
          />
        </svg>
      )}
      {variant === CharacterRIconVariant.ON && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="12" fill="#00C3DD" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.4753 13.7197V18H7.6189V6.00293H12.699C15.6609 6.00293 17.1199 7.67285 17.1199 9.93164C17.1199 11.9092 15.7927 12.9814 14.9753 13.3154L17.366 18H14.1492L12.1189 13.7197H10.4753ZM10.4753 11.6631H12.2419C13.3669 11.6631 14.1228 11.0918 14.1228 9.95801C14.1228 8.77148 13.3054 8.18262 12.2683 8.18262H10.4753V11.6631Z"
            fill="white"
          />
        </svg>
      )}
    </i>
  );
}

export default CharacterRIcon;
